import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import it from '@angular/common/locales/it';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { FuseProgressBarComponent } from '@fuse/components/progress-bar/progress-bar.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { fuseConfig } from './fuse-config';
import { ItalianPaginatorIntl } from './i18n/it-paginator-intl';
import { VerticalLayout1Component } from './layout/vertical/layout-1/layout-1.component';
import { JWTRequestInterceptor } from './main/utils/jwt/jwt-request-interceptor';
import { JWTResponseInterceptor } from './main/utils/jwt/jwt-response-interceptor';
import { LoaderInterceptor } from './main/utils/loader.interceptor';
import { ContenutiService } from './main/utils/service/contenuti.service';
import { LoaderService } from './main/utils/service/loader.service';
import { NotificaService } from './main/utils/service/notifica.service';
import { UtentiService } from './main/utils/service/utente.service';
import { FUSE_CONFIG } from '@fuse/services/config.service';
import { AggiornamentoDatiPendingGuard } from './main/utils/guards/aggiornamento-dati-pending.guard';

registerLocaleData(it);

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule),
    canActivateChild: [AggiornamentoDatiPendingGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, {
      useHash: true,
      preloadingStrategy: NoPreloading,
      enableTracing: false
    }),
    ToastrModule.forRoot(),

    // Fuse modules
    FuseProgressBarComponent,
    FuseSharedModule,

    // App modules
    VerticalLayout1Component
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideServiceWorker('/ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    { provide: FUSE_CONFIG, useValue: fuseConfig },
    CookieService,
    AggiornamentoDatiPendingGuard,
    NotificaService,
    LoaderService,
    UtentiService,
    ContenutiService,
    { provide: MatPaginatorIntl, useValue: ItalianPaginatorIntl() },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    [
      { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: JWTRequestInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: JWTResponseInterceptor,
        multi: true
      }
    ],
    { provide: LOCALE_ID, useValue: 'it-IT' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
